/* Place It Decor — theme interactivity
   Vanilla JS, no dependencies. Progressive enhancement only.
   Shopify Theme 2.0 compatible: all init functions are re-invoked on
   shopify:section:load so the Theme Editor works correctly. */
(function () {
  'use strict';

  var money = function (cents) {
    var f = (window.PID && window.PID.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return f.replace(/\{\{\s*amount\s*\}\}/g, amount);
  };
  window.PIDmoney = money;

  /* ─── Scope-aware query helper ──────────────────────────────── */
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }
  function $1(sel, root) { return (root || document).querySelector(sel); }

  /* ─── Scroll reveal ─────────────────────────────────────────── */
  function initReveal(root) {
    var els = $$('.reveal', root);
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ─── Before / After sliders ────────────────────────────────── */
  function initBeforeAfter(root) {
    $$('[data-ba]', root).forEach(function (r) {
      if (r._baInit) return;
      r._baInit = true;
      var after = r.querySelector('.ba__after');
      var handle = r.querySelector('.ba__handle');
      var dragging = false;
      function set(clientX) {
        var rect = r.getBoundingClientRect();
        var p = Math.max(2, Math.min(98, ((clientX - rect.left) / rect.width) * 100));
        after.style.clipPath = 'inset(0 ' + (100 - p) + '% 0 0)';
        handle.style.left = p + '%';
      }
      var initial = parseFloat(r.getAttribute('data-ba')) || 50;
      after.style.clipPath = 'inset(0 ' + (100 - initial) + '% 0 0)';
      handle.style.left = initial + '%';
      r.addEventListener('mousedown', function (e) { dragging = true; set(e.clientX); });
      r.addEventListener('touchstart', function (e) { dragging = true; set(e.touches[0].clientX); }, { passive: true });
      window.addEventListener('mousemove', function (e) { if (dragging) set(e.clientX); });
      window.addEventListener('touchmove', function (e) { if (dragging) set(e.touches[0].clientX); }, { passive: true });
      window.addEventListener('mouseup', function () { dragging = false; });
      window.addEventListener('touchend', function () { dragging = false; });
    });
  }

  /* ─── Generic tab groups ────────────────────────────────────── */
  function initTabs(root) {
    $$('[data-tabs]', root).forEach(function (group) {
      if (group._tabsInit) return;
      group._tabsInit = true;
      group.querySelectorAll('[data-tab]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-tab');
          group.querySelectorAll('[data-tab]').forEach(function (b) {
            b.classList.toggle('active', b === btn);
          });
          group.querySelectorAll('[data-tabpanel]').forEach(function (p) {
            p.classList.toggle('active', p.getAttribute('data-tabpanel') === id);
          });
        });
      });
    });
  }

  /* ─── Steppers — always increment/decrement by exactly 1 ────── */
  function initSteppers(root) {
    $$('[data-stepper]', root).forEach(function (s) {
      if (s._stepperInit) return;
      s._stepperInit = true;
      var input = s.querySelector('input') || s.querySelector('.val');
      var min = parseInt(s.getAttribute('data-min') || '1', 10);
      function val() { return parseInt((input.value || input.textContent), 10) || min; }
      function setVal(v) {
        v = Math.max(min, v);
        if (input.value !== undefined) input.value = v; else input.textContent = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var dec = s.querySelector('[data-dec]');
      var inc = s.querySelector('[data-inc]');
      if (dec) dec.addEventListener('click', function () { setVal(val() - 1); });
      if (inc) inc.addEventListener('click', function () { setVal(val() + 1); });
    });
  }

  /* ─── Mobile nav ────────────────────────────────────────────── */
  function initMobileNav() {
    var nav = document.getElementById('mobile-nav');
    if (!nav || nav._navInit) return;
    nav._navInit = true;
    $$('[data-open-nav]').forEach(function (b) {
      b.addEventListener('click', function () { nav.classList.add('open'); document.body.style.overflow = 'hidden'; });
    });
    nav.querySelectorAll('[data-close-nav], .mobile-nav__scrim').forEach(function (b) {
      b.addEventListener('click', function () { nav.classList.remove('open'); document.body.style.overflow = ''; });
    });
  }

  /* ─── Cart drawer ───────────────────────────────────────────── */
  var Cart = {
    drawer: null, scrim: null,
    open: function () {
      if (this.drawer) { this.drawer.classList.add('open'); this.scrim.classList.add('open'); }
    },
    close: function () {
      if (this.drawer) { this.drawer.classList.remove('open'); this.scrim.classList.remove('open'); }
    },
    refresh: function () {
      var self = this;
      fetch('/?section_id=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var cur = document.getElementById('cart-drawer');
          if (cur) { cur.innerHTML = html; self.bindDrawer(); }
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
            $$('[data-cart-count]').forEach(function (el) {
              el.textContent = c.item_count;
              el.style.display = c.item_count > 0 ? '' : 'none';
            });
          });
        });
    },
    bindDrawer: function () {
      var self = this;
      this.drawer = document.getElementById('cart-drawer');
      if (!this.drawer) return;
      this.drawer.querySelectorAll('[data-close-cart]').forEach(function (b) {
        b.addEventListener('click', function () { self.close(); });
      });
      this.drawer.querySelectorAll('[data-line-change]').forEach(function (el) {
        el.addEventListener('click', function () {
          self.changeLine(el.getAttribute('data-key'), parseInt(el.getAttribute('data-qty'), 10));
        });
      });
    },
    changeLine: function (key, qty) {
      var self = this;
      fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () { self.refresh(); });
    },
    add: function (form) {
      var self = this;
      var data = new FormData(form);
      var btn = form.querySelector('[type=submit]');
      if (btn) { btn.disabled = true; }
      fetch('/cart/add.js', { method: 'POST', body: data })
        .then(function (r) { return r.json(); })
        .then(function () { self.refresh(); self.open(); })
        .catch(function () {})
        .then(function () { if (btn) { btn.disabled = false; } });
    }
  };

  function initCart() {
    Cart.scrim = document.getElementById('cart-scrim');
    Cart.bindDrawer();
    $$('[data-open-cart]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); Cart.open(); });
    });
    if (Cart.scrim) Cart.scrim.addEventListener('click', function () { Cart.close(); });
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form.matches('[data-ajax-cart]')) {
        e.preventDefault();
        Cart.add(form);
      }
    });
    window.PIDCart = Cart;
  }

  /* ─── Panel calculator ──────────────────────────────────────── */
  function initCalculator(root) {
    $$('[data-calc]', root).forEach(function (calc) {
      if (calc._calcInit) return;
      calc._calcInit = true;
      var w = calc.querySelector('[data-calc-w]');
      var h = calc.querySelector('[data-calc-h]');
      var sqftPerPanel = parseFloat(calc.getAttribute('data-sqft')) || 8;
      var price = parseFloat(calc.getAttribute('data-price')) || 0;
      var extra = 10;
      var outArea = calc.querySelector('[data-calc-area]');
      var outPanels = calc.querySelector('[data-calc-panels]');
      var outCost = calc.querySelector('[data-calc-cost]');
      var useBtn = calc.querySelector('[data-calc-use]');
      var qtyInput = document.querySelector('[data-qty-input]');

      function compute() {
        var area = ((parseFloat(w.value) || 0) * (parseFloat(h.value) || 0)) / 144;
        var base = Math.ceil(area / sqftPerPanel) || 0;
        var withExtra = Math.ceil(base * (1 + extra / 100));
        var panels = Math.ceil(withExtra / 3) * 3;
        if (panels < 3) panels = 3;
        if (outArea) outArea.textContent = area.toFixed(1) + ' sqft';
        if (outPanels) outPanels.textContent = panels + ' panels';
        if (outCost) outCost.textContent = window.PIDmoney(panels * price * 100);
        if (useBtn) { useBtn.textContent = 'Use ' + panels + ' panels →'; useBtn.setAttribute('data-panels', panels); }
      }
      [w, h].forEach(function (i) { if (i) i.addEventListener('input', compute); });
      calc.querySelectorAll('[data-extra]').forEach(function (b) {
        b.addEventListener('click', function () {
          extra = parseInt(b.getAttribute('data-extra'), 10);
          calc.querySelectorAll('[data-extra]').forEach(function (x) { x.classList.toggle('active', x === b); });
          compute();
        });
      });
      if (useBtn && qtyInput) {
        useBtn.addEventListener('click', function () {
          qtyInput.value = useBtn.getAttribute('data-panels') || 3;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
      compute();
    });
  }

  /* ─── Generic modal ─────────────────────────────────────────── */
  function initModals(root) {
    $$('[data-open-modal]', root).forEach(function (b) {
      if (b._modalInit) return;
      b._modalInit = true;
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-open-modal');
        var modal = document.getElementById(id);
        var scrim = document.getElementById(id + '-scrim');
        if (modal) modal.classList.add('open');
        if (scrim) scrim.classList.add('open');
      });
    });
    $$('[data-close-modal]', root).forEach(function (b) {
      if (b._modalCloseInit) return;
      b._modalCloseInit = true;
      b.addEventListener('click', function () {
        var modal = b.closest('.modal') || document.getElementById(b.getAttribute('data-close-modal'));
        if (modal) {
          modal.classList.remove('open');
          var scrim = document.getElementById(modal.id + '-scrim');
          if (scrim) scrim.classList.remove('open');
        }
      });
    });
    $$('.modal-scrim', root).forEach(function (s) {
      if (s._scrimInit) return;
      s._scrimInit = true;
      s.addEventListener('click', function () {
        s.classList.remove('open');
        var modal = document.getElementById(s.id.replace('-scrim', ''));
        if (modal) modal.classList.remove('open');
      });
    });
  }

  /* ─── PDP gallery ───────────────────────────────────────────── */
  function initGallery(root) {
    $$('[data-gallery]', root).forEach(function (g) {
      if (g._galleryInit) return;
      g._galleryInit = true;
      var main = g.querySelector('[data-gallery-main]');

      g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {

          /* 1 — scroll page to top of the product section smoothly */
          var pdp = g.closest('.pdp') || g.closest('.section') || g;
          pdp.scrollIntoView({ behavior: 'smooth', block: 'start' });

          /* 2 — mark active thumb */
          g.querySelectorAll('[data-gallery-thumb]').forEach(function (x) { x.classList.remove('active'); });
          t.classList.add('active');

          /* 3 — update main image only */
          if (!main) return;
          var img = t.getAttribute('data-img');
          if (img) {
            main.innerHTML = '<img src="' + img + '" alt="">';
          } else {
            main.innerHTML = '<div class="tex-' + (t.getAttribute('data-tex') || 'plain-wall') + '" style="position:absolute;inset:0;"></div>';
          }

        });
      });
    });
  }

  /* ─── Auto-cycling installation steps ───────────────────────── */
  function initInstall(root) {
    $$('[data-install]', root).forEach(function (inst) {
      if (inst._installInit) return;
      inst._installInit = true;
      var steps = inst.querySelectorAll('[data-install-step]');
      var bricks = inst.querySelectorAll('.brick');
      var status = inst.querySelectorAll('[data-install-status]');
      var idx = 0;
      function render(i) {
        steps.forEach(function (s, n) { s.classList.toggle('active', n === i); });
        bricks.forEach(function (b, n) {
          var on = i === 0 ? false : i === 1 ? n < 4 : i === 2 ? n < 12 : true;
          b.classList.toggle('on', on);
        });
        status.forEach(function (s, n) { s.style.display = n === i ? '' : 'none'; });
      }
      steps.forEach(function (s, n) {
        s.addEventListener('click', function () { idx = n; render(idx); });
      });
      render(0);
      if (steps.length) {
        setInterval(function () { idx = (idx + 1) % steps.length; render(idx); }, 3200);
      }
    });
  }

  /* ─── Visualizer page ───────────────────────────────────────── */
  function initVisualizer(root) {
    var viz = $1('[data-visualizer]', root);
    if (!viz || viz._vizInit) return;
    viz._vizInit = true;
    var overlays = viz.querySelectorAll('[data-viz-overlay]');
    viz.querySelectorAll('[data-viz-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        viz.querySelectorAll('[data-viz-step]').forEach(function (x) {
          x.classList.remove('active');
          var arrow = x.querySelector('svg:last-child');
          if (arrow) arrow.style.display = 'none';
        });
        b.classList.add('active');
        var arrow = b.querySelector('svg:last-child');
        if (arrow) arrow.style.display = '';
      });
    });
    viz.querySelectorAll('[data-viz-panel]').forEach(function (b) {
      b.addEventListener('click', function () {
        viz.querySelectorAll('[data-viz-panel]').forEach(function (x) { x.classList.remove('active'); });
        b.classList.add('active');
        overlays.forEach(function (ov) {
          ov.className = 'tex-' + b.getAttribute('data-viz-panel');
          ov.setAttribute('data-viz-overlay', '');
        });
      });
    });
    viz.querySelectorAll('[data-viz-room]').forEach(function (b) {
      b.addEventListener('click', function () {
        viz.querySelectorAll('[data-viz-room]').forEach(function (x) { x.classList.remove('active'); });
        b.classList.add('active');
        var stage = viz.querySelector('[data-viz-stage]');
        if (stage) {
          stage.className = 'scene-' + b.getAttribute('data-viz-room');
          stage.setAttribute('data-viz-stage', '');
        }
      });
    });
    var up = viz.querySelector('[data-viz-upload]');
    if (up) {
      up.addEventListener('change', function (e) {
        var f = e.target.files[0]; if (!f) return;
        var url = URL.createObjectURL(f);
        var stage = viz.querySelector('[data-viz-stage]');
        if (stage) {
          stage.style.background = 'url(' + url + ') center/cover';
          stage.style.backgroundSize = 'cover';
          stage.className = '';
          stage.setAttribute('data-viz-stage', '');
        }
      });
    }
  }

  /* ─── PDP variant selector ──────────────────────────────────── */
  function initVariantSelector(root) {
    $$('[data-product-form]', root).forEach(function (form) {
      if (form._variantInit) return;
      form._variantInit = true;
      var select = form.querySelector('[data-variant-select]');
      if (!select) return;
      var priceEl = document.querySelector('[data-price]');
      function syncVariant() {
        var opts = [];
        form.querySelectorAll('[data-option-input]:checked').forEach(function (i) { opts.push(i.value); });
        if (!opts.length) return;
        var target = opts.join(' / ');
        Array.from(select.options).forEach(function (opt) {
          var title = (opt.textContent || '').split('—')[0].trim();
          if (title === target) { select.value = opt.value; }
        });
        var ev = new Event('change', { bubbles: true });
        select.dispatchEvent(ev);
      }
      form.querySelectorAll('[data-option-input]').forEach(function (i) {
        i.addEventListener('change', function () {
          i.closest('.swatches').querySelectorAll('.chip').forEach(function (c) {
            c.style.background = ''; c.style.color = ''; c.style.borderColor = '';
          });
          var chip = i.nextElementSibling;
          if (chip) {
            chip.style.background = 'var(--ink)';
            chip.style.color = 'var(--paper)';
            chip.style.borderColor = 'var(--ink)';
          }
          syncVariant();
        });
      });
    });
  }

  /* ─── Master init ───────────────────────────────────────────── */
  function initAll(root) {
    initReveal(root);
    initBeforeAfter(root);
    initTabs(root);
    initSteppers(root);
    initCalculator(root);
    initModals(root);
    initGallery(root);
    initInstall(root);
    initVisualizer(root);
    initVariantSelector(root);
  }

  /* ─── Boot ──────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
    initMobileNav();
    initCart();
  });

  /* ─── Shopify Theme Editor — section lifecycle ──────────────── */
  document.addEventListener('shopify:section:load', function (e) {
    var container = e.target;
    initAll(container);
    initMobileNav();
  });

  document.addEventListener('shopify:section:select', function (e) {
    if (e.target) e.target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  document.addEventListener('shopify:block:select', function (e) {
    var block = e.target;
    var tabBtn = block.querySelector('[data-tab]') || block.closest('[data-tabpanel]');
    if (!tabBtn) return;
    var panelId = block.id || block.getAttribute('data-shopify-editor-block');
    var btn = document.querySelector('[data-tab="' + panelId + '"]');
    if (btn) btn.click();
  });

})();